module.exports = __webpack_public_path__ + "img/16.315d6cde.svg";